import { connect } from 'react-redux';
import { SecretField } from 'components/common';
import { Box, BoxEmpty } from 'components/common/box';
import { FormGroup } from 'components/common/form';

export default connect(state => state)(({
  messages,
  pageState: { course },
  serverConfig
}) => (
  <div className="integrations">
    <Box title={messages.settingsIntegrations}>
      {serverConfig.showCourseHash ? (
        <div>
          <FormGroup
            label={messages.settingsCourseHash}
          >
            <SecretField
              value={course.hash}
            />
          </FormGroup>
        </div>
      ) : (
        <BoxEmpty
          padding={0}
          text={messages.settingsIntegrationsNone}
        />
      )}
    </Box>
  </div>
));
